(() => {
  if (window.chouolMapInitialized) return;
  window.chouolMapInitialized = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ch-map-load]');
    if (!button) return;
    const panel = button.closest('[data-ch-map-panel]');
    if (!panel || panel.querySelector('iframe')) return;
    const url = new URL(button.dataset.chMapSrc, window.location.origin);
    if (url.origin !== 'https://maps.google.com' || url.pathname !== '/maps') return;
    const frame = document.createElement('iframe');
    frame.title = 'Map showing the CHOUOL business address in El Monte, California';
    frame.src = url.href;
    frame.loading = 'lazy';
    frame.referrerPolicy = 'no-referrer-when-downgrade';
    frame.allowFullscreen = true;
    panel.replaceChildren(frame);
  });
})();
